import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TransportPauseStart } from '../model/out/transport-pause-start';
import { ServiceResponse } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { TransportPauseEnd } from '../model/out/transport-pause-end';
import { HttpService } from '@sdbn/appclient';

@Injectable({
  providedIn: 'root'
})
export class PauseTransportService {

  constructor(private tmcHttpService: HttpService) { }

  startPause(start: TransportPauseStart): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext(environment.pauseTransportEndpoint + '/start', start);
  }

  endPause(end: TransportPauseEnd): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext(environment.pauseTransportEndpoint + '/end', end);
  }

}
